module.exports = __webpack_public_path__ + "static/placeholder_1-e9fb5ee7e68cdb5e690b28af48408654.mp4";